import { z } from 'zod'

export const ORDER_OCR_LEASE_MINUTES = 10

export const orderOcrRecordsSchema = z.array(z.record(z.string(), z.union([z.string(), z.number().finite(), z.null()])))

// OCRの生応答ではなく、人が確認する取込形式を共有し、画面から未検証JSONを使わせない。
export const orderOcrExtractionSchema = z.object({
  records: orderOcrRecordsSchema,
  orderCount: z.number().int().nonnegative(),
  validationIssues: z.array(z.string()),
})
export type OrderOcrExtraction = z.infer<typeof orderOcrExtractionSchema>
